import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import * as authAPI from "../../api/auth";

const getAuthState = (state) => state.auth;
const initialState = {
  isAuth: false,
  token: {
    "userId": null,
    "courseId": null,
    "sessionId": null,
    "env": null,
    "iss": null,
    "iat": null,
    "aud": null,
    "sub": null,
    "exp": null,
    "botName": "",
    vectorToken: "",
    voiceId: "",
    characterType: "",
    isCustomBot: false
  },
  status: "fetchingFromLocalStore", // "loggingIn" | "loggingOut" | "sessionExpired"
  expires: null,
  error: null,
  admin: false,
  ui: {
    login: {},
    msg: "",
  },
}
const login = createAsyncThunk("auth/login", async (params) => {
  // const res = await authAPI.login(params);
  // return res.data;
  return {
  }
});

const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async ({ email, user }) => {
    if (user === null) return;
  }
);
const authSlice = createSlice({
  name: "auth",
  initialState: initialState,

  reducers: {
    persistLogin: (state) => {

      state.status = "idle";
    },
    userregister: (state) => {
      state.isAuth = false;
      state.token = null;
      state.expires = null;
      state.status = "unregistered";
    },
    logout: (state) => {
      state.isAuth = false;
      state.token = null;
      state.expires = null;
      state.status = "loggingOut";
    },
    setSessionData: (state, action) => {
      if (action.payload) {
        state.token = {
          ...action.payload,
          isCustomBot: !!action.payload.vectorToken,
        };
      } else {
        state.token = { ...initialState, isCustomBot: false };
      }
    },
    sessionExpired: (state) => {
      // if (isLocalStorageAvailable()) {
      //   localStorage.removeItem("token");
      //   localStorage.removeItem("expires");
      // }
      state.isAuth = false;
      state.token = null;
      state.status = "sessionExpired";
      state.expires = null;
      state.error = "sessionExpired";
    },
  },
});

const { setSessionData, persistLogin, logout, sessionExpired } = authSlice.actions;

export default authSlice.reducer;

export {
  persistLogin,
  login,
  logout,
  sessionExpired,
  resetPassword,
  getAuthState,
  setSessionData
};
